import { render } from "./InternalInfoPage.vue?vue&type=template&id=5f6f503f&scoped=true"
import script from "./InternalInfoPage.vue?vue&type=script&lang=js"
export * from "./InternalInfoPage.vue?vue&type=script&lang=js"

import "./InternalInfoPage.vue?vue&type=style&index=0&id=5f6f503f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6f503f"]])

export default __exports__